module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.$t('store.label')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-9@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.moduleDefinitionModules), function(definitionModule) {
    return (definitionModule.type !== 'tool') ? _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('store-card', {
      attrs: {
        "definitionModule": definitionModule
      }
    })], 1) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.moduleDefinitionModules), function(definitionModule) {
    return (definitionModule.type === 'tool') ? _c('div', {
      staticClass: "l-col-12@md"
    }, [_c('store-card-tool', {
      attrs: {
        "definitionModule": definitionModule
      }
    })], 1) : _vm._e()
  }), 0)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3475272","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Store/Base.vue
// module id = 3425
// module chunks = 0